import urls from '../api_urls/login'
import { _post, _upload, _get } from '@/axios/request'
import $axios from '../config'

const UPLOAD = '/auth/public/upload_file'
const UPLOAD_WATERMARK = '/auth/public/uploadFile/water'

// 用户登录
export function login (params) {
  return _post(urls.LOGIN, params)
}

// 用户登出
export function logout () {
  return _post(urls.LOGOUT)
}

// 获取菜单
export function getMenu () {
  return _post(urls.GET_MENU)
}

// 修改密码
export function updatePassword (params) {
  return _post(urls.UPDATE_PASSWORD, params)
}

// 修改密码
export function publicUpdatePassword (params) {
  return _post(urls.PUBLIC_UPDATE_PASSWORD, params)
}

// 上传图片
export function uploadImg (params) {
  return _upload(UPLOAD, params)
}

// 上传带水印的文件
export function uploadHasWatermarkFile (params) {
  return _upload(UPLOAD_WATERMARK, params)
}

// 修改头像
export function updateHeadImg (params) {
  return _post(urls.UPDATE_HEAD_IMG, params)
}

// 切换语言
export function changeLanguage (params) {
  return _post(urls.CHANGE_LANGUAGE, params)
}

// 获取用户信息
export function getUserInfo () {
  return _post(urls.GET_USER_INFO)
}

// 获取权限列表
export function getPermisson () {
  return _post(urls.GET_PERMISSION)
}

// 获取隐私条款
export function getStatement () {
  return _post(urls.GET_STATEMENT)
}

// 发送邮件
export function sendEmail (params) {
  return _post(urls.SEND_EMAIL, params)
}

// 忘记密码提交
export function forgetPassword (params) {
  return _post(urls.FORGET_PASSWORD, params)
}

// 发送消息
export function sendMessage (params) {
  return _post(urls.SEND_MESSAGE, params)
}

// 检查密码
export function checkPass (params) {
  return _post(urls.CHECK_PASS, params)
}
// 修改密码发送邮件
export function sendEmailForChangePwd (params) {
  return _post(urls.SEND_EMAIL_FOR_CHANGE_PWD, params)
}
// 修改密码发送邮件
export function publicSendEmailForChangePwd (params) {
  return _post(urls.PUBLIC_SEND_EMAIL_FOR_CHANGE_PWD, params)
}
// 升级数据防爬,接口请求次数过多后请求验证码
export function getCheckCode (params) {
  return $axios({
    url: urls.GET_CHECK_CODE,
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}

// 提交防爬验证码
export function submitChckeCode (params) {
  return _post(urls.SUBMIT_CHECK_CODE, params)
}

// 增加扫描次数
export function incrScannedTimes (params) {
  return _post(urls.INCR_SCANNED_TIME, params)
}

// 用户注册-发送验证码
export function getRegisterCode (params) {
  return _post(urls.GET_REGISTER_CODE, params)
}

// 用户注册
export function register (params) {
  return _post(urls.REGISTER, params)
}

// 获取公司
export function getCustomerCompanyList (params) {
  return _post(urls.GET_CUSTOMER_COMPANY_LIST, params)
}

// 获取公司
export function getCompanyList (params) {
  return _post(urls.GET_COMPANY_LIST, params)
}

// 更新权限变更等提示状态
export function updateSession (params) {
  return _post(urls.UPDATE_SESSION, params)
}

// 校验账号状态
export function checkAccount (params) {
  return _post(urls.CHECK_ACCOUNT, params)
}

// 注册激活
export function activate (params) {
  return _get(urls.ACTIVATE, params)
}

// 重新发送邮件
export function reActivate (params) {
  return _post(urls.REACTIVATE, params)
}

// 更新用户信息
export function updateUserInfo (params) {
  return _post(urls.UPDATE_USER_INFO, params)
}

// 获取注销状态
export function getDegretionInfo (params) {
  return _post(urls.GET_DEGRETION_INFO, params)
}

// 获取注销状态
export function writtenOff (params) {
  return _post(urls.WRITTEN_OFF, params)
}

export function checkPassword (params) {
  return _post(urls.CHECK_PASSWORD, params)
}

export function checkNewPassword (params) {
  return _post(urls.CHECK_NEW_PASSWORD, params)
}

export function publicCheckPassword (params) {
  return _post(urls.PUBLIC_CHECK_PASSWORD, params)
}

// 获取Customer Company
export function getCustomerCompanyData (params) {
  return _post(urls.getCustomerCompanyData, params)
}
// 验证是否今天已经发过了解锁邮件
export function unlockEmailWhetherSent (params) {
  return _post(urls.unlockEmailWhetherSent, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/login.js